import { render, staticRenderFns } from "./VisitPointList.vue?vue&type=template&id=3cb21a74&scoped=true"
import script from "./VisitPointList.vue?vue&type=script&lang=js"
export * from "./VisitPointList.vue?vue&type=script&lang=js"
import style0 from "./VisitPointList.vue?vue&type=style&index=0&id=3cb21a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb21a74",
  null
  
)

export default component.exports